module.exports = __webpack_public_path__ + "img/plebianj_logo_thumb.6b90577f.jpg";